var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixDevcenterCheckoutV1PurchasedItem from '@wix/ambassador-devcenter-checkout-v1-purchased-item/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var PaymentCycle;
(function (PaymentCycle) {
    PaymentCycle["NO_CYCLE"] = "NO_CYCLE";
    PaymentCycle["MONTHLY"] = "MONTHLY";
    PaymentCycle["YEARLY"] = "YEARLY";
    PaymentCycle["ONE_TIME"] = "ONE_TIME";
    PaymentCycle["TWO_YEARS"] = "TWO_YEARS";
    PaymentCycle["THREE_YEARS"] = "THREE_YEARS";
    PaymentCycle["FOUR_YEARS"] = "FOUR_YEARS";
    PaymentCycle["FIVE_YEARS"] = "FIVE_YEARS";
})(PaymentCycle || (PaymentCycle = {}));
export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["UNKNOWN_INVOICE_STATUS"] = "UNKNOWN_INVOICE_STATUS";
    InvoiceStatus["PAYMENT_FAILED"] = "PAYMENT_FAILED";
    InvoiceStatus["PAID"] = "PAID";
    InvoiceStatus["REFUNDED"] = "REFUNDED";
    InvoiceStatus["VOIDED"] = "VOIDED";
    InvoiceStatus["CHARGEDBACK"] = "CHARGEDBACK";
})(InvoiceStatus || (InvoiceStatus = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _getMeteredBillingChargesRequest = {};
const _getMeteredBillingChargesResponse = {};
const _getPurchaseHistoryRequest = {};
const _getPurchaseHistoryResponse = {};
const _getSitePaymentMethodsStatusRequest = {};
const _getSitePaymentMethodsStatusResponse = {};
const _getUrlRequest = {};
const _getUrlResponse = {};
/**
 * Retrieves the URL for a Wix checkout page for the specified paid plan of your app.
 *
 *
 * This call succeeds only in case you have previously
 * [set up an external pricing page in the Wix Developers Center](https://dev.wix.com/docs/build-apps/build-your-app/pricing-plans/set-up-an-external-pricing-page).
 *
 * The returned checkout URL is valid for 48 hours.
 *
 * This API allows your app to manage your pricing page outside of Wix while
 * still using the standard Wix checkout flow.
 * @param productId - ID of your app's paid plan to retrieve the Wix checkout URL for. Check the
 * Wix Developers Center for a list of your app's supported product IDs.
 * @public
 * @documentationMaturity preview
 * @requiredField productId
 * @adminMethod
 */
export function getUrl(productId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            productId: '$[0]',
            successUrl: '$[1].successUrl',
            testCheckout: '$[1].testCheckout',
            billingCycle: '$[1].billingCycle',
            countryCode: '$[1].countryCode',
            languageCode: '$[1].languageCode',
            chargeOverride: '$[1].chargeOverride',
            couponCode: '$[1].couponCode',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getUrlRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getUrlResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([productId, options]);
        const reqOpts = ambassadorWixDevcenterCheckoutV1PurchasedItem.getUrl(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'productId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of the site owner's past purchases for your app.
 *
 *
 * You don't have to explicitly pass an identifier for the Wix site as part of
 * the request, since this information is taken automatically from the context.
 *
 * The response doesn't include any details about cancellations.
 * @public
 * @documentationMaturity preview
 * @adminMethod
 */
export function getPurchaseHistory() {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {};
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[0];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getPurchaseHistoryRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getPurchaseHistoryResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#purchases']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([]);
        const reqOpts = ambassadorWixDevcenterCheckoutV1PurchasedItem.getPurchaseHistory(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, []);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves information about the site's enabled payment methods.
 *
 *
 * Checks whether online, offline, Wix POS, and external POS payments are
 * enabled.
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function getSitePaymentMethodsStatus() {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {};
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[0];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getSitePaymentMethodsStatusRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getSitePaymentMethodsStatusResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([]);
        const reqOpts = ambassadorWixDevcenterCheckoutV1PurchasedItem.getSitePaymentMethodsStatus(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, []);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Triggers Wix to call the
 * [List Custom Charges SPI](https://dev.wix.com/docs/rest/internal-only/premium/custom-charges-spi/custom-charges-provider-v1/list-charges).
 *
 *
 * Wix doesn't use the response from _List Charges_ SPI to actually create an
 * invoice that's sent to the customer. Instead, calling _Get Metered Billing Charges_
 * allows you confirm that your integration with the Custom Charges SPI is
 * working as intended.
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function getMeteredBillingCharges(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            currency: '$[0].currency',
            startDate: '$[0].startDate',
            endDate: '$[0].endDate',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getMeteredBillingChargesRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getMeteredBillingChargesResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixDevcenterCheckoutV1PurchasedItem.getMeteredBillingCharges(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=devcenter-checkout-v1-purchased-item.universal.js.map